const productMixin = {
  methods: {
    //获取商品详情跳转地址
    getDetailUrl: function (type, id) {
      if (type === 4) {
        return `/zhichong/${id}`;
      } else {
        return `/detail/${id}`;
      }
    },
  },
};

export default productMixin;
